import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";

import "../css/SelectTime.scss";
import { inputTypes } from "../const";
import Icon, { icons } from "./Icons";

// const hours = [...Array(24).keys()].map(hour => `${hour < 10 ? '0' : ''}${hour}:00`)

const hours = [
  "00:00",
  "00:30",
  "01:00",
  "01:30",
  "02:00",
  "02:30",
  "03:00",
  "03:30",
  "04:00",
  "04:30",
  "05:00",
  "05:30",
  "06:00",
  "06:30",
  "07:00",
  "07:30",
  "08:00",
  "08:30",
  "09:00",
  "09:30",
  "10:00",
  "10:30",
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  "16:00",
  "16:30",
  "17:00",
  "17:30",
  "18:00",
  "18:30",
  "19:00",
  "19:30",
  "20:00",
  "20:30",
  "21:00",
  "21:30",
  "22:00",
  "22:30",
  "23:00",
  "23:30",
];

export default (props) => {
  const { hour, onChange, style, forceClose, setActiveInput, inputType, ariaLabel } =
    props;

  const [isOpen, setIsOpen] = useState(false);
  const scrollRef = useRef(null);
  const triggerRef = useRef(null);
  const optionRefs = useRef([]);
  const listboxId = `time-options-${inputType}`;

  useEffect(() => {
    if (isOpen && forceClose) setIsOpen(false);
  }, [forceClose, isOpen]);

  const handleClick = () => {
    const nextOpen = !isOpen;
    setIsOpen(nextOpen);
    setActiveInput(nextOpen ? inputType : inputTypes.none);

    if (nextOpen) {
      setTimeout(() => {
        const index = hours.findIndex((h) => h === hour);
        if (scrollRef.current) scrollRef.current.scrollTo(0, index * 27);
      }, 0);
    }
  };

  useEffect(() => {
    if (!isOpen) return;
    const index = Math.max(0, hours.findIndex((h) => h === hour));
    const option = optionRefs.current[index];
    if (option) option.focus();
  }, [hour, isOpen]);

  const closeAndFocusTrigger = () => {
    setIsOpen(false);
    setActiveInput(inputTypes.none);
    setTimeout(() => triggerRef.current && triggerRef.current.focus(), 0);
  };

  const selectHour = selectedHour => {
    onChange(selectedHour);
    closeAndFocusTrigger();
  };

  const focusOption = index => {
    const boundedIndex = Math.max(0, Math.min(index, hours.length - 1));
    const option = optionRefs.current[boundedIndex];
    if (option) option.focus();
  };

  const handleOptionKeyDown = (event, selectedHour, index) => {
    if (event.key === "ArrowDown") {
      event.preventDefault();
      focusOption(index + 1);
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      focusOption(index - 1);
    } else if (event.key === "Home") {
      event.preventDefault();
      focusOption(0);
    } else if (event.key === "End") {
      event.preventDefault();
      focusOption(hours.length - 1);
    } else if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      selectHour(selectedHour);
    } else if (event.key === "Escape") {
      event.preventDefault();
      closeAndFocusTrigger();
    }
  };

  return (
    <div className="time-container" style={style}>
      <button
        type="button"
        className="time-trigger"
        ref={triggerRef}
        aria-label={ariaLabel}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        aria-controls={listboxId}
        onClick={handleClick}
        onKeyDown={event => {
          if (event.key === "ArrowDown" || event.key === "ArrowUp") {
            event.preventDefault();
            if (!isOpen) handleClick();
          } else if (event.key === "Escape" && isOpen) {
            event.preventDefault();
            closeAndFocusTrigger();
          }
        }}
      >
        <Icon icon={icons.hour} className="time-icon" />
        <span className="hour-value">{hour}</span>
      </button>
      {isOpen && (
        <div className="hours-container">
          <div className="hours-content" id={listboxId} role="listbox" aria-label={ariaLabel} ref={scrollRef}>
            {hours.map((h, index) => (
              <div
                key={h}
                className={classNames(
                  "hour-item",
                  hour === h ? "selected" : ""
                )}
                role="option"
                aria-selected={hour === h}
                tabIndex={hour === h ? 0 : -1}
                ref={option => { optionRefs.current[index] = option; }}
                onClick={() => selectHour(h)}
                onKeyDown={event => handleOptionKeyDown(event, h, index)}
              >
                {h}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
